module.exports = __webpack_public_path__ + "img/t3-purple.fda14544.png";